import { fetchGetOnlineAccount } from '@iwoca/lapi-client/edge';

import { getAccountNumber } from './getAccountNumber';

export type OpenBankingBank = {
    bank_id: string;
    bank_name: string;
    logo_url: string;
};

export type LinkedAccount = {
    accountId: string;
    bankName?: string;
    logoUrl?: string;
    accountNumberMasked?: string;
};

const findBankByName = (provider: string | null, banks: OpenBankingBank[]) => {
    if (!provider) return undefined;
    const normalised = provider.toLowerCase();
    return banks.find((bank) => bank.bank_name.toLowerCase() === normalised);
};

export const getLinkedAccounts = (
    response: Awaited<ReturnType<typeof fetchGetOnlineAccount>> | undefined,
    banks: OpenBankingBank[] = []
): LinkedAccount[] => {
    if (!response?.data) return [];

    return response.data
        .filter((entry) => entry.status?.code === 'active')
        .flatMap((entry) => {
            const bank = findBankByName(entry.provider, banks);
            return entry.accounts.map((account) => {
                const accountNumber = getAccountNumber(account.extra);
                return {
                    accountId: String(account.account_id),
                    bankName: entry.provider ?? undefined,
                    logoUrl: bank?.logo_url,
                    accountNumberMasked: accountNumber?.slice(-4)
                };
            });
        });
};
